// -----------------------------------------------------------------------------
// Copyright 2022 Open Climate Tech Contributors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// -----------------------------------------------------------------------------

import React from 'react';

/**
 * Provides a simple footer for the main app layout.
 *
 * @returns {React.Element}
 */
export default function AppFooter(props) {
  // TODO:
  //   - Link Open Climate Tech if the final design calls for it
  //   - Section links (About, Privacy, Terms)
  //   - Social media links
  //   - Donation link
  return (
    0,
    (<div className="c7e-app-footer">Open Climate Tech › Wildfire Check</div>)
  );
}
